import { set } from 'shared/lib/lodash/lodash';

import { Category } from '../model/types/CategorySchema';

export const mapCategories = (categories: Category[]) => {
    const parsedData = {};

    categories.forEach((cat) => {
        set(parsedData, cat.id, {
            ...cat,
        });
    });

    return parsedData;
};
